interface ApplyListSkeletonProps {
  rows?: number;
}

export default function ApplyListSkeleton({ rows = 6 }: ApplyListSkeletonProps) {
  return (
    <div className="flex flex-col gap-xs">
      {Array.from({ length: rows }).map((_, index) => (
        <div
          key={index}
          className="relative h-[105px] shrink-0 overflow-hidden rounded bg-gray_darken shadow-layer1"
        >
          <div className="absolute inset-0 animate-shimmer bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,0.7)_50%,transparent_100%)] bg-[length:200%_100%]" />
        </div>
      ))}
    </div>
  );
}
